import React from 'react';
import { useField } from 'formik';

import SelectInput from 'components-new/select-input/select-input';
import type {
  SelectInputProps,
  SelectOption,
} from 'components-new/select-input/select-input';

interface SelectFieldProps extends SelectInputProps {
  name: string;
  type?: string;
}

const SelectField: React.FC<SelectFieldProps> = (props) => {
  const { name, multiple, ...other } = props;
  const [field, meta, helpers] = useField(name);

  const handleSelectedOptionsChange = (
    selectedOptions: SelectOption | SelectOption[],
  ) => {
    if (multiple) {
      const values = (selectedOptions as SelectOption[]).map(
        (option) => option.value,
      );
      helpers.setValue(values);
    } else {
      helpers.setValue((selectedOptions as SelectOption).value);
    }
  };

  return (
    <SelectInput
      name={name}
      value={field.value}
      multiple={multiple}
      onSelectedOptionsChange={handleSelectedOptionsChange}
      error={meta.touched ? meta.error : undefined}
      {...other}
    />
  );
};

export default SelectField;
